(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["announcement-entry-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('yarbo-entry-popup');
    if (!popup) return;

    const cookieName = 'yarbo_entry_popup_closed';

    const hasCookie = document.cookie
      .split(';')
      .map((cookie) => cookie.trim())
      .some((cookie) => cookie.indexOf(cookieName + '=1') === 0);

    if (hasCookie) return;

    popup.hidden = false;

    const closePopup = () => {
      document.cookie = cookieName + '=1; path=/; SameSite=Lax';
      popup.hidden = true;
    };

    const closeButton = popup.querySelector('[data-popup-close]');
    const overlay = popup.querySelector('.yarbo-entry-popup__overlay');

    if (closeButton) {
      closeButton.addEventListener('click', closePopup);
    }

    if (overlay) {
      overlay.addEventListener('click', closePopup);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
